var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-container"}},[(_vm.mapInformation.point)?_c('h5',{staticClass:"map-title"},[_vm._v("\n    "+_vm._s(_vm.$t("message.map"))+"\n  ")]):_vm._e(),_c('div',{ref:"map",staticClass:"map",attrs:{"id":"view"}})])}
var staticRenderFns = []

export { render, staticRenderFns }